export const STEPS = [
  "User Type Master",
  "Location Type Master",
  "Location Master",
  "Medical Specialty Master",
  "Medical Procedure Master",
  "Disease Master",
  "Symptom Category Master",
  "Symptom Master",
  "Aggravating Factor Master",
  "Allergy Type Master",
  "Allergy Master",
  "Trauma Type Master",
  "Trauma Master",
  "Addiction Category Master",
  "Addiction Sub Category Master",
  "Addiction Master",
  "Patient Condition Master",
  "Investigation Type Master",
  "Investigation Group Master",
  "Investigation Master",
  "Establishment Type Master",
  "Establishment Sub Type Master",
  "Medical Degree Master",
  "Specialization Master",
  "Specialization Type Master",
  "Accreditation Master",
  "Department Type Master",
  "Hospital Department Master",
  "Designation Master",
  "Profile Topic Master",
  "Profile Sub Topic Master",
  "Service Type Master",
  "Service Master",
  "Question Type Master",
  "Question Master",
  "Option Master",
  "Question Group Master",
  "Establishment Master",
  "Doctor Master",
  "Event Type Master",
  "Login Log",
  "Immunization Master",
  "Vaccine Master",
  "Hospital Management",
  "Doctor Management",
  "Hospital Admin",
  "Relationship Master",
  "Blood Group Master",
  "Patient User",
  "Therapeutic Class Master",
  "Medicine Salt Master",
  "Medical Prescription Master",
  "Dosage Master",
  "Patient Prescription Medicine Master",
  "Patient Case Master",
  "Patient Complaints",
  "Case Diagnosis",
  "Patient Investigation",
  "Supplier Type Master",
  "Product Category Master",
  "Product Sub Category Master",
  "Product Master",
  "Medical Services Master", // step 62
  "", // step 63 — reserved (unused numbering gap, keeps step numbers aligned with array indices)
  "Location Admin",
  "Doctor Admin",
  "Hospital List",
  "Doctor List",
  "User Master",
  "User Admin",
  "MVT Journey Phase Master",
  "MVT Journey Steps Master",
  "OEM Master",
  "D2D Communication",
  "D2D Chat",
];

/** Special step for the analytics dashboard screen (kept out of the numbered STEPS range). */
export const DASHBOARD_STEP = 100;

/** Special step for the Health Tracker screen (admin-only; kept out of the numbered STEPS range). */
export const HEALTH_TRACKER_STEP = 101;

/** Steps that render the create-login admin UI and their modes */
export const LOGIN_ADMIN_STEPS = {
  45: "establishment",
  64: "location",
  65: "doctor",
  69: "user",
};

export const isLoginAdminStep = (step) => Object.prototype.hasOwnProperty.call(LOGIN_ADMIN_STEPS, step);

export const LOGIN_ADMIN_PAGE_TITLE = "Create Login";

export const LOGIN_ADMIN_DESCRIPTIONS = {
  45: "Create and manage hospital admin logins linked to establishments.",
  64: "Create and manage location admin logins for regional administration.",
  65: "Create and manage doctor admin logins linked to doctor profiles.",
  69: "Create and manage logins for users from User Master.",
};

export const APP_CONFIG_SECTIONS = [
  {
    id: "location-mgmt",
    label: "Location Management",
    items: [
      { step: 1, label: "Location Type" },
      { step: 2, label: "Location Master" },
    ],
  },
  {
    id: "establishment-types",
    label: "Establishment Type",
    items: [
      { step: 20, label: "Establishment Type" },
      { step: 21, label: "Establishment Sub Type" },
    ],
  },
  {
    id: "product-catalog",
    label: "Product Catalog",
    items: [
      { step: 58, label: "Supplier Type" },
      { step: 59, label: "Product Category" },
      { step: 60, label: "Product Sub Category" },
      { step: 61, label: "Product Master" },
      { step: 72, label: "OEM Master" },
    ],
  },
  {
    id: "products-services",
    label: "Products/Services",
    items: [
      { step: 31, label: "Products/Services Type" },
      { step: 32, label: "Products/Services Master" },
    ],
  },
  {
    id: "event-mgmt",
    label: "Event Management",
    items: [
      { step: 39, label: "Event Type" },
      { step: null, label: "Event Master" },
    ],
  },
  {
    id: "hospital-departments",
    label: "Hospital Departments",
    items: [
      { step: 26, label: "Department Type" },
      { step: 27, label: "Hospital Department" },
    ],
  },
  {
    id: "patient-profile",
    label: "Patient Profile",
    items: [
      { step: 29, label: "Profile Topics" },
      { step: 30, label: "Profile Sub Topics" },
      { step: 33, label: "Question Types" },
      { step: 34, label: "Questions" },
      { step: 35, label: "Options" },
    ],
  },
  {
    id: "master-tables",
    label: "Master Tables",
    items: [
      { step: null, label: "Picture/Video Gallery" },
      { step: null, label: "News/Articles" },
      { step: null, label: "Knowledge Base" },
      { step: 28, label: "Designations" },
      { step: 22, label: "Medical Degrees" },
      { step: 25, label: "Accreditations" },
      { step: 46, label: "Relationship Master" },
      { step: 47, label: "Blood Group Master" },
    ],
  },
  {
    id: "mvt-journey",
    label: "MVT Journey",
    items: [
      { step: 70, label: "MVT Journey Phase" },
      { step: 71, label: "MVT Journey Steps" },
    ],
  },
];

export const CLINICAL_SETUP_SECTIONS = [
  {
    id: "medical-specialities",
    label: "Medical Specialities",
    step: 3,
  },
  {
    id: "medical-services",
    label: "Medical Services",
    step: 62,
  },
  {
    id: "specialization-master",
    label: "Specialization Master",
    items: [
      { step: 24, label: "Specialization Type" },
      { step: 23, label: "Specialization" },
    ],
  },
  {
    id: "symptoms",
    label: "Symptoms",
    items: [
      { step: 6, label: "Symptom Types" },
      { step: 7, label: "Symptoms" },
    ],
  },
  {
    id: "diseases-diagnosis",
    label: "Diseases/Diagnosis",
    step: 5,
  },
  {
    id: "surgical-procedures",
    label: "Medical Procedure",
    step: 4,
  },
  {
    id: "allergies",
    label: "Allergies",
    items: [
      { step: 9, label: "Allergy Type" },
      { step: 10, label: "Allergies" },
    ],
  },
  {
    id: "trauma",
    label: "Trauma",
    items: [
      { step: 11, label: "Trauma Type" },
      { step: 12, label: "Trauma Master" },
    ],
  },
  {
    id: "addictions",
    label: "Addictions",
    items: [
      { step: 13, label: "Addiction Category" },
      { step: 14, label: "Addiction Sub Category" },
      { step: 15, label: "Addiction Master" },
    ],
  },
  {
    id: "investigations",
    label: "Investigations",
    items: [
      { step: 17, label: "Investigation Type" },
      { step: 18, label: "Investigation Group" },
      { step: 19, label: "Investigation Master" },
    ],
  },
  {
    id: "immunization",
    label: "Immunization",
    items: [
      { step: 41, label: "Immunization Master" },
      { step: 42, label: "Vaccine Master" },
    ],
  },
  {
    id: "therapeutic-classes",
    label: "Therapeutic Classes",
    items: [
      { step: 49, label: "Therapeutic Class Master" },
      { step: 50, label: "Medicine Salt Master" },
    ],
  },
  {
    id: "patient-case-mgmt",
    label: "Patient Case Management",
    items: [
      { step: 54, label: "Patient Case Master" },
      { step: 55, label: "Patient Complaints" },
      { step: 56, label: "Case Diagnosis" },
      { step: 57, label: "Patient Investigation" },
      { step: 73, label: "D2D Communication" },
      { step: 74, label: "D2D Chat" },
    ],
  },
  {
    id: "medical-prescriptions",
    label: "Medical Prescriptions",
    items: [
      { step: 51, label: "Medical Prescription Master" },
      { step: 52, label: "Dosage Master" },
      { step: 53, label: "Patient Prescription Medicine Master" },
    ],
  },
];

export const USER_MANAGEMENT_SECTIONS = [
  {
    id: "user-type",
    label: "User Type Master",
    step: 0,
  },
  {
    id: "user-master",
    label: "User Master",
    step: 68,
  },
  {
    id: "user-admin",
    label: "User Admin",
    step: 69,
  },
  {
    id: "establishments",
    label: "Establishments",
    items: [
      { step: 37, label: "Establishment Master" },
      { step: 38, label: "Doctor Master" },
      { step: 43, label: "Hospital Management" },
      { step: 44, label: "Doctor Management" },
    ],
  },
  {
    id: "location-admin",
    label: "Location Admin",
    step: 64,
  },
  {
    id: "hospital-admin",
    label: "Hospital Admin",
    step: 45,
  },
  {
    id: "doctor-admin",
    label: "Doctor Admin",
    step: 65,
  },
  {
    id: "hospital-list",
    label: "Hospital List",
    step: 66,
  },
  {
    id: "doctor-list",
    label: "Doctor List",
    step: 67,
  },
  {
    id: "patient-user",
    label: "Patient User",
    step: 48,
  },
];

export const LOG_MANAGEMENT_SECTIONS = [
  {
    id: "login-log",
    label: "Login Log",
    step: 40,
  },
];

export const getGroupSteps = (group) => {
  if (group.step != null) return [group.step];
  if (group.sections) {
    return group.sections.flatMap((section) => {
      if (section.step != null) return [section.step];
      return (section.items || []).filter((item) => item.step != null).map((item) => item.step);
    });
  }
  return group.steps;
};

export const MENU_GROUPS = [
  {
    id: "dashboard",
    label: "Dashboard",
    step: DASHBOARD_STEP,
  },
  {
    id: "health-tracker",
    label: "Health Tracker",
    step: HEALTH_TRACKER_STEP,
  },
  {
    id: "app-config",
    label: "App Configuration",
    sections: APP_CONFIG_SECTIONS,
  },
  {
    id: "clinical-setup",
    label: "Clinical Setup",
    sections: CLINICAL_SETUP_SECTIONS,
  },
  {
    id: "user-mgmt",
    label: "User Management",
    sections: USER_MANAGEMENT_SECTIONS,
  },
  {
    id: "log-mgmt",
    label: "Log Management",
    sections: LOG_MANAGEMENT_SECTIONS,
  },
];

export const STEP_DESCRIPTIONS = [
  "Define user types for system accounts (e.g. Doctor, Hospital, Patient).",
  "Define location type categories (Country, State, City).",
  "Add a location entry and link it to a location type.",
  "Define medical specialties available in the system.",
  "Add medical procedures and link them to a medical specialty.",
  "Add diseases with specialty, Yes/No flags, and ICD-10/ICD-11 codes.",
  "Define symptom categories (General, Respiratory, Neurological, etc.).",
  "Add symptoms with an optional associated picture.",
  "Define factors that worsen symptoms (e.g. exertion, cold weather).",
  "Define allergy categories (Food, Drug, Environmental, etc.).",
  "Add allergies and link them to an allergy type.",
  "Define trauma categories (Blunt, Penetrating, Burn, etc.).",
  "Add traumas and link them to a trauma type.",
  "Define addiction categories (Substance, Behavioral, etc.).",
  "Define addiction sub categories linked to an addiction category.",
  "Add an addiction linked to category, sub category, description, and clinical classification.",
  "Define patient condition statuses (Stable, Critical, etc.).",
  "Define investigation categories (Laboratory, Radiology, etc.).",
  "Add investigation groups linked to an investigation type.",
  "Add investigations with ranges and linked specialties.",
  "Define establishment types (Hospitals, Pharmacy, Pathology, Hotel/Guest Houses, Supplier).",
  "Define establishment sub types linked to an establishment type (e.g. Single Specialty Hospital, Multi Specialty Hospital).",
  "Define medical degree titles (MBBS, MD, MS, etc.).",
  "Define specializations and link them to a specialization type.",
  "Define specialization types (Medical, Surgical, etc.).",
  "Define accreditation titles (NABH, JCI, ISO, etc.).",
  "Define hospital department types (Clinical, Diagnostic, etc.).",
  "Add hospital departments and link them to a department type.",
  "Define designations (Chief Medical Officer, Consultant, etc.).",
  "Define profile section topics (Medical History, Lifestyle, etc.).",
  "Add profile sub topics linked to a profile topic.",
  "Define service types (Consultation, Diagnostic, etc.).",
  "Add services linked to a service type with title and description.",
  "Define question types (Multiple Choice, Yes/No, Text, etc.).",
  "Add questions linked to a profile topic, profile sub topic, or service with type, text, and media.",
  "Add answer options linked to a question with sequence and weightage.",
  "Add question groups linked to a profile sub topic and service.",
  "Add and manage establishment records.",
  "Add and manage doctor basic records and create logins. Doctors complete their full profile after login.",
  "Define event types (Appointment, Follow-up, Emergency Visit, etc.).",
  "View user login activity with timestamps, status, and location.",
  "Add immunizations with type, gender, age group, and applicable comorbidity disease.",
  "Add vaccines with age group, gender, vaccine name, and schedule detail.",
  "View hospital profile, media, and connect details.",
  "View doctor profile, qualifications, fees, and contact details.",
  "Create and manage hospital admin logins linked to establishments.",
  "Define family/emergency contact relationships (Father, Mother, Spouse, etc.).",
  "Define blood group types (A+, B+, O+, AB+, etc.).",
  "Add and manage patient user records with contact and emergency details.",
  "Define therapeutic drug classes (e.g. Analgesics, Antibiotics, Antihypertensives).",
  "Add medicine salts linked to a therapeutic class with formula, description, and schedule.",
  "Add medical prescriptions linked to patient cases with doctor, establishment, images, and duration.",
  "Define dosage types (e.g. O.D., B.D., T.D.S., S.O.S.) for prescription medicines.",
  "Add prescription medicines linked to case, prescription, salt, dosage, duration, and flags.",
  "Add patient case records with referring doctor, medical specialty, medical service type, date & time, and comments.",
  "Add patient complaints linked to a case with symptom, severity, aggravating factors, and SOS flag.",
  "Add case diagnoses linked to a case with disease, status, and comments.",
  "Add patient investigations linked to a case with diagnosis, scan/report uploads, abnormalities, and date.",
  "Define supplier types for product vendors and supply chain partners.",
  "Define product categories for catalog organization.",
  "Define product sub categories linked to a product category.",
  "Add products with descriptions, images, video link, profile PDF, comments, and status.",
  "Define medical services for clinical case classification (e.g. Consultation, Surgery, Diagnostic).",
  "", // step 63 — reserved (unused numbering gap)
  "Create and manage location admin logins for regional administration.",
  "Create and manage doctor admin logins linked to doctor profiles.",
  "Browse hospitals from Establishment Master in the public website card layout.",
  "Browse doctors from Doctor Master in the public website card layout.",
  "Add and manage user records with profile, contact, and location details.",
  "Create and manage logins for users from User Master.",
  "Define MVT journey phases (e.g. Enquiry, Evaluation, Treatment, Follow-up).",
  "Add MVT journey steps linked to a phase with TAT, input type, and output type.",
  "Create and manage original equipment manufacturers, contacts, documents, and certifications.",
  "Manage doctor-to-doctor communication for patient referrals, including diagnosis, procedure, cost, call scheduling, and status.",
  "Manage doctor-to-doctor chat messages for patient referrals, including uploads and moderation status.",
];

export const HOSPITAL_STEPS = [
  "Profile Management",
  "Patient Queries",
  "Awards & Recognitions",
  "News & Articles",
  "Digital CME",
  "Picture/ Video Gallery",
];

export const HOSPITAL_STEP_DESCRIPTIONS = [
  "Manage your hospital profile, contact details, and media.",
  "View and respond to patient queries.",
  "Manage awards and recognitions for your hospital.",
  "Publish and manage news articles.",
  "Manage digital CME content and sessions.",
  "Upload pictures and add video links for your hospital gallery.",
];

export const DOCTOR_STEPS = [
  "Profile Management",
  "Patient Queries",
  "Awards & Recognitions",
  "News & Articles",
  "Digital CME",
  "Picture/ Video Gallery",
];

export const DOCTOR_STEP_DESCRIPTIONS = [
  "Manage your doctor profile, contact details, and media.",
  "View and respond to patient queries.",
  "Manage awards and recognitions for your profile.",
  "Publish and manage news articles.",
  "Manage digital CME content and sessions.",
  "Upload pictures and add video links for your gallery.",
];

export const DOCTOR_MENU_GROUPS = [
  {
    id: "doctor-menu",
    label: "Menu Options",
    sections: [
      { id: "profile", label: "Profile Management", step: 0 },
      { id: "queries", label: "Patient Queries", step: 1 },
      { id: "awards", label: "Awards & Recognitions", step: 2 },
      { id: "news", label: "News & Articles", step: 3 },
      { id: "cme", label: "Digital CME", step: 4 },
      { id: "gallery", label: "Picture/ Video Gallery", step: 5 },
    ],
  },
];

export const HOSPITAL_MENU_GROUPS = [
  {
    id: "hospital-menu",
    label: "Menu Options",
    sections: [
      { id: "profile", label: "Profile Management", step: 0 },
      { id: "queries", label: "Patient Queries", step: 1 },
      { id: "awards", label: "Awards & Recognitions", step: 2 },
      { id: "news", label: "News & Articles", step: 3 },
      { id: "cme", label: "Digital CME", step: 4 },
      { id: "gallery", label: "Picture/ Video Gallery", step: 5 },
    ],
  },
];
